import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { onboardingQuestionnaireActions } from '../../../../../../../store';
import { EXTRACTION_JOB_STATUS } from './constants';
import { writeInsuranceExtractionEntry } from './utils';
import { useInsuranceCardExtractionEntry } from './useInsuranceExtractionSelectors';

import type { AppDispatch } from '../../../../../../../store';
import type { InsuranceType } from '../../../../../../../utils/types';

export default function useMarkInsuranceExtractionReviewed(insuranceType: InsuranceType): void {
  const dispatch = useDispatch<AppDispatch>();
  const { onboardingQuestionnaireId } = useParams<'onboardingQuestionnaireId'>();
  const entry = useInsuranceCardExtractionEntry(insuranceType);

  useEffect(() => {
    if (
      !onboardingQuestionnaireId ||
      entry?.status !== EXTRACTION_JOB_STATUS.SUCCEEDED ||
      !entry.needsReview ||
      entry.reviewedAfterCompletion
    ) {
      return;
    }
    dispatch(onboardingQuestionnaireActions.markInsuranceExtractionReviewed({ insuranceType }));
    writeInsuranceExtractionEntry(onboardingQuestionnaireId, insuranceType, {
      ...entry,
      reviewedAfterCompletion: true,
    });
  }, [dispatch, entry, insuranceType, onboardingQuestionnaireId]);
}
